import { Link } from '@remix-run/react'

import {
    Container,
    Stack,
    Heading,
    Text,
    HStack,
    Button,
    Image,
} from '@chakra-ui/react'

import theme from '../../../../Config/theme'

import BrowsingSvg from '../../../../Assets/browsing.svg'
import CustomHighlight from '../../../../Components/Elements/CustomHighlight'

const HomeHero = () => {
    return (
        <Container
            maxW={'6xl'}
            px={{ base: 6, md: 3 }}
            py={5}
        >
            <Stack
                direction={{ base: 'column', md: 'row' }}
                justify={'space-between'}
                align={'center'}
            >
                <Stack
                    direction={'column'}
                    spacing={6} ml={{ base: 5 }}
                    alignItems={{ base: 'center', sm: 'center', md: 'start', lg: 'start' }}
                    textAlign={{ base: 'center', sm: 'center', md: 'start', lg: 'start' }}
                >
                    <Heading fontSize={'4xl'} fontWeight={700}>
                        Find & Apply <br /> For <CustomHighlight query={['scholarships']}>Scholarships</CustomHighlight> <br /> Easily
                    </Heading>
                    <Text fontSize={'2xl'} fontWeight={600}>
                        Maximize your college funding opportunities with our comprehensive scholarship search and application platform for college students.
                    </Text>

                    <HStack spacing={3} pb={6}>
                        <Link to='/scholarships/browse'>
                            <Button
                                bgColor={theme.default.defaultColor}
                                _active={{}}
                                _focus={{}}
                                _hover={{}}
                                size={'lg'}
                                borderRadius={'full'}
                                fontWeight={700}
                                color={'black'}
                            >
                                Start browsing</Button>
                        </Link>
                    </HStack>
                </Stack>

                <Container>
                    <Image
                        w={'100%'}
                        h={'100%'}
                        minW={{ base: 'auto', md: '30rem' }}
                        objectFit={'cover'}
                        src={BrowsingSvg}
                        rounded={'md'}
                    />
                </Container>
            </Stack>
        </Container>
    )
}

export default HomeHero